
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1078","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M690.392 356.783l387.503 33.415L784.169 645.12 872.017 1024 538.948 822.973 205.879 1024l88.387-378.88L.001 390.198l387.503-32.876L538.948 0l151.444 356.783zM336.303 844.531L538.947 722.19 742.13 845.07l-53.895-230.669 178.931-155.217-236.059-20.48-92.16-217.735-91.621 217.196-236.058 20.48 178.93 155.217-53.895 230.669z"}})])
          )
        }
      }
    